export default __webpack_public_path__ + "static/media/onestar5.b0465720.jpg";